import { e } from "./engine-user-agent.js";
var r = e.match(/firefox\/(\d+)/i),
  i = !!r && +r[1];
export { i as e };